import { render, staticRenderFns } from "./ConnectionsHistoryTable.vue?vue&type=template&id=4a5ffe00&scoped=true"
import script from "./ConnectionsHistoryTable.vue?vue&type=script&lang=js"
export * from "./ConnectionsHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5ffe00",
  null
  
)

export default component.exports